export default __webpack_public_path__ + "155ec719ac070e4b6f908e5a58829d7c.svg";